<!-- Non-closeable phone verification freeze modal -->
<app-modal
  [isOpen]="isOpen"
  [closeOnBackdrop]="false"
  [customHeader]="true"
  [customFooter]="true"
>
  <div modal-header class="flex items-center gap-3">
    <div class="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center flex-shrink-0">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.36 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.34 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
      </svg>
    </div>
    <h2 class="text-lg font-bold">Phone Verification Required</h2>
  </div>

  <p class="text-sm text-gray-600">Please verify your number to continue using the application.</p>

  <div *ngIf="exotelNumber" class="bg-gray-50 border border-gray-200 rounded-xl px-4 py-3 mt-4">
    <p class="text-xs text-gray-500 mb-0.5">Call from your registered Exotel number</p>
    <p class="text-base font-semibold text-gray-900">{{ exotelNumber }}</p>
  </div>

  <ol class="list-decimal pl-5 flex flex-col gap-2 text-sm text-gray-700 mt-4">
    <li>
      <span *ngIf="exotelNumber; else noExotelNumber">
        From the number above, give a missed call to <strong>{{ missedCallNumber }}</strong>
      </span>
      <ng-template #noExotelNumber>
        Give a missed call from your Exotel number on record to <strong>{{ missedCallNumber }}</strong>
      </ng-template>
    </li>
    <li>You will receive a verification call back from Exotel on that same number</li>
  </ol>

  <div *ngIf="errorMessage"
    class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-sm font-medium mt-4">
    {{ errorMessage }}
  </div>

  <div modal-footer class="w-full flex justify-end">
    <button type="button" class="btn btn-primary px-8" [disabled]="isChecking" (click)="onCheckVerification()">
      <span *ngIf="isChecking" class="loading loading-spinner loading-sm mr-2"></span>
      {{ isChecking ? 'Checking...' : 'I have verified' }}
    </button>
  </div>
</app-modal>
